//import moment from 'moment'; -- in use

export default {

    methods: {
        createBarData(arr_ty, arr_py, type){

            var bookings_py = 0;
            var i;
            let v = 0;
            for(i = 0; i < arr_py.length; ++i){                
                bookings_py += arr_py[i].nr_bookings;
            }
            //console.log("telling", bookings_py);

            var bookings_ty = 0;
            for(i = 0; i < arr_ty.length; ++i){                
                bookings_ty += arr_ty[i].nr_bookings;
            }
            //console.log("telling YTD", bookings_ty);


            let xvalues_ty = [], yvalues_ty = [], barcolors_ty = [], maxvalue_ty = 0;
            let yvalues_py = [], barcolors_py = [], maxvalue_py = 0, maxvalue = 0;

            for (let i = 0; i < arr_ty.length; i++) {
                v = +((arr_ty[i].nr_bookings) / (bookings_ty / 100)).toFixed(0);
                xvalues_ty.push(arr_ty[i].timeslot);
                yvalues_ty.push(v);
                if (v > maxvalue_ty) {
                    maxvalue_ty = v;
                }
                barcolors_ty.push("rgb(0,128,0,0.5)"); // color of other days of this year
            }

            for (let i = 0; i < arr_py.length; i++) {
                v = +((arr_py[i].nr_bookings) / (bookings_py / 100)).toFixed(0);
                yvalues_py.push(v)
                if (v > maxvalue_py) {
                    maxvalue_py = v;
                }
                barcolors_py.push("rgba(0,0,255,0.5)"); // color of previous year
            }

            maxvalue = maxvalue_ty;
            if(maxvalue < maxvalue_py){
                maxvalue = maxvalue_py;
            }

            let datasets = [];
            var currentYear = new Date().getFullYear();
            var previousYear = currentYear - 1;

            // previous year 
            dataset_element = {
                "backgroundColor": barcolors_py,
                "hoverBackgroundColor": "rgba(0,0,255,0.3)",   
                "data": yvalues_py,
                "borderColor": "#006400",
                "hoverBorderColor": "rgba(0,0,255,1)",     
                "label": "% " + previousYear,
                "borderWidth": 1,
            };
            datasets.push(dataset_element);

            // this year
            let dataset_element = {
                "backgroundColor": barcolors_ty,
                "hoverBackgroundColor": "rgba(34,139,34,0.3)",   
                "data": yvalues_ty,
                "borderColor": "#006400",
                "hoverBorderColor": "rgba(34,139,34,1)",     
                "label": "% " + currentYear,
                "borderWidth": 1,
            };
            datasets.push(dataset_element);            

            let xdata = {
                "labels": xvalues_ty,
                "datasets": datasets,
            };

            let xminmax = {
                "min": 0,
                "max": (((maxvalue - maxvalue%2) / 2) * 2) + 2,
            };
            let xscales= {};
            if (type === 'horizontalBar') {
                xscales = {"x": xminmax};
            } else {
                xscales = {"y": xminmax};
            }

            let xtitle = {
                "display": false,
                "text": "Number of bookings",
            };
            
            let xlegend = {
                "legend": {
                    "display": true
                },
                datalabels: {
                    formatter: function(value, context){
                        return context !== null ? value === 0 ? '' : '': '';                         
                    }
                }                   
            };

            let xoptions = {
                "plugins": xlegend,
                "title": xtitle,
                "responsive": true,
                "maintainAspectRatio": false,
                "lineTension": 1,
                "scales": xscales,
            };
             
            let chartData = {
                "type": type,
                "data": xdata,
                "options": xoptions,
            };

            this.title = "Bookings " + previousYear + ": " + bookings_py + ", " + currentYear + " YTD: " +  bookings_ty;
            return chartData;

        },                
        checkFormat(arr) {
            if (!Array.isArray(arr)) {
                console.log("parameter is not an array");
                return false;
            }
            if (arr.length > 0) {
                if (!('nr_bookings' in arr[0] && 'bookingdate' in arr[0])) {
                    console.log("array elements have unknown composition");
                    return false;
                }
            }
            return true;
        }        
    }
}